<template>
  <div class="pagination-box clearfix">
    <div class="clearfix">
      <el-pagination
        background
        layout="prev, pager, next"
        :page-sizes="[10,20,50]"
        @current-change="handleCurrentChange"
        :page-size="pagesize"
        :current-page.sync="data.current_page"
        :total="data.total">
      </el-pagination>
    </div>
  </div>

</template>

<script>
  export default {
    name: "pagination",
    props:{
      data:{}
    },
    data() {
      return {
        pagesize: 10,
        page: 1
      }
    },
    watch:{
      pagesize() {
        this.$emit('change', this.page, this.pagesize)
      }
    },
    methods: {
      handleCommand(command) {
        this.pagesize = Number(command)
      },
      handleCurrentChange(v){
        this.page = v
        this.$emit('change', v, this.pagesize)
      }
    }
  }
</script>

<style lang="less">
  .pagination-drow .el-dropdown-menu__item:focus, .pagination-drow .el-dropdown-menu__item:not(.is-disabled):hover {
    background: #C60505;
    color: #fff!important;
  }

  .pagination-drow .el-dropdown-menu__item:focus, .pagination-drow .el-dropdown-menu__item:not(.is-disabled) {
    color: #DADADA !important;
  }

  .el-pagination__sizes {
    height: 40px !important;
    line-height: 40px !important;
    .el-input__inner {
      height: 40px !important;
      line-height: 40px !important;
    }
  }

  .pagination-box {
    color: #DDDDDD !important;
    padding: 85px 0 80px 280px ;

    .pagesize-box {
      width: 78px;
      height: 40px;
      float: left;
      line-height: 40px;
      text-align: center;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(221, 221, 221, 1);
      border-radius: 4px;
      cursor: pointer;
      font-size: 12px;

      .el-dropdown-link {
        color: #DADADA !important;
      }
    }

    .el-pagination {
      float: left;

      .btn-prev, .btn-next, .el-icon-more, .el-pager li {
        width: 40px;
        height: 40px;
        line-height: 40px;
        color: #DDDDDD !important;
        background-color: #FFFFFF;
      }

      .btn-prev, .btn-next {
        color: #DDDDDD !important;
      }

      .el-pager li:hover, .btn-next:hover, .btn-prev:hover {
        color: #C60505 !important;
      }

      .el-pager .active:hover {
        color: #fff !important;
      }

      .el-pager {
        .active {
          background-color: #C60505 !important;
          color: #fff !important;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/common/pagination.vue